import type { RouteObject } from 'react-router';
import { LeadsPage } from '../leads/LeadsPage';

/** Engaged pizzerias moved here by hand from Leads. Their profiles stay at /leads/:id. */
export const routes: RouteObject[] = [{ path: '/prospects', element: <LeadsPage segment="prospect" /> }];
